export default [
  {
    for: 'a11y-scanner',
    actions: {
      read: true,
    },
  },
  {
    for: 'a11y-scan',
    actions: {
      read: true,
    },
  },
  {
    for: 'a11y-report',
    actions: {
      read: true,
    },
  },
  {
    for: 'a11y-quickscan',
    actions: {
      read: true,
      create: true,
    },
  },
];
